<template>
  <div>
    <AppHeader />
    <HeroSection />
    <DownloadSection />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '../components/Header.vue'
import HeroSection from '../components/Hero.vue'
import DownloadSection from '../components/Download.vue'
import AppFooter from '../components/Footer.vue'

export default {
  name: 'HomePage',
  components: {
    AppHeader,
    HeroSection,
    DownloadSection,
    AppFooter
  }
}
</script> 